import React, { useEffect, useState, useRef, use } from 'react';
import ReactDOM from 'react-dom';

import './CallBackRequestModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpdeskApiCall from 'HelpdeskApiCall';
import microPhoneRequest from 'HELPDESK/CommonResources/images/microPhone.svg';
import config from 'config';
import { CALLBACKREQUESTTABS } from 'HELPDESK/CommonResources/Utils/constants';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import { toast } from 'react-toastify';
import deleteRequestIcon from 'HELPDESK/CommonResources/images/deleteRequestIcon.svg';
import Spinner from 'HELPDESK/CommonResources/SpinnerLoader/Spinner';
import callCenterIcon from 'HELPDESK/CommonResources/images/callRequestCenter.gif';
import CallQueueIndicator from './CallQueueIndicator/CallQueueIndicator';
const CallBackRequestModal = ({ isOpen, onClose, ignoreRef, courseData, moduleData }) => {
  const popupRef = useRef(null);

  const [moduleList, setModuleList] = useState({});
  const [moduleListFetching, setModuleListFetching] = useState(false);
  const [totalTestCaseCount, setTotalTestCaseCount] = useState(0);
  const [moduleId, setModuleId] = useState('');
  const [moduleIdWarning, setModuleIdWarning] = useState('');
  const [isRaisingRequest, setIsRaisingRequest] = useState(false);
  const [activeTab, setActiveTab] = useState('Pending Call Request');
  const [historyList, setHistoryList] = useState({});
  const [historyListFetching, setHistoryListFetching] = useState(false);
  const [historyListCount, setHistoryListCount] = useState(0);
  const [sortedKey, setSortedKey] = useState([]);
  const [pendingSortedKey, setPendingSortedKey] = useState([]);
  const [pendingRequestList, setPendingRequestList] = useState([]);
  const [pendingRequestFetching, setPendingRequestFetching] = useState([]);
  const [totalRequestCount, setTotalRequestCount] = useState([]);
  const [deletingRequest, setDeletingRequest] = useState(false)
  const [deleteRequestId, setDeleteRequestId] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  useEffect(() => {
    if (activeTab === 'Pending Call Request') {
      apiCallToGetPendingRequestList();
    } else {
      apiCallToGetCallBackHistoryList();
    }
    apiCallToSubscriptionModuleList()
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, activeTab]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target) && !ignoreRef.current.contains(event.target)) {
      onClose();
    }
  };
  // API CALL METHOD TO GET MODULE LIST
  const apiCallToSubscriptionModuleList = async () => {
    setModuleListFetching(true)

    let requestData = {
      "iid": config.institute_id,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'GetPMCurrentSubscriptionWiseModuleList',
      requestData,
      '/api/helpDesk/employee/Onboarding.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        apiCallToSubscriptionModuleList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult.data;
        let totalTestCaseCount = jsonResponse.APIResult?.totalTestCaseCount;

        setModuleList(apiResult);
        setModuleListFetching(false);
        setTotalTestCaseCount(totalTestCaseCount);
      } else {
        setModuleList({});
        setModuleListFetching(false);
      }
    }
  }

  // API CALL METHOD TO GET MODULE LIST
  const apiCallToRaiseRequest = async () => {
    setIsRaisingRequest(true);
    setSortedKey([])

    let request = {
      module_id: moduleId,
      iid: config.institute_id,
      added_by: config.faculty_id
    }

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'pmTool_addCallBackRequest',
      request,
      '/api/projectManagement/callBackRequest/callBackClient.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        apiCallToRaiseRequest();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        if (jsonResponse.APIResult.status == 'success') {
          // onClose();
          setIsRaisingRequest(false);
          toast.success(jsonResponse.APIResult.message + jsonResponse.APIResult?.insert_id)
          setModuleId('');
          setModuleIdWarning('');
          apiCallToGetPendingRequestList()
        }
        else {
          setIsRaisingRequest(false);

        }



      } else {
        setModuleList({});
        setIsRaisingRequest(false);
      }
    }
  }

  // API CALL METHOD TO GET CALL HISTORY LIST
  const apiCallToGetCallBackHistoryList = async () => {
    setHistoryListFetching(false);
    let requestData = {
      iid: config.institute_id,
      client_id: config.faculty_id
    }

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'pmTool_getCallBackRequestHistory',
      requestData,
      '/api/projectManagement/callBackRequest/callBackClient.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        apiCallToGetCallBackHistoryList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult.data;
        let totalTestCaseCount = jsonResponse.APIResult.totaRecords;
        setSortedKey(jsonResponse.APIResult.sorted_key)

        setHistoryList(apiResult);
        setHistoryListFetching(false);
        setHistoryListCount(totalTestCaseCount);
      } else {
        setHistoryList({});
        setHistoryListFetching(false);
      }
    }
  }

  // API CALL METHOD TO PENDING REQUEST LIST
  const apiCallToGetPendingRequestList = async () => {
    setPendingRequestFetching(false)
    setPendingSortedKey([]);
    let requestData = {
      iid: config.institute_id,
      client_id: config.faculty_id
    }

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'pmTool_getPendingCallBackRequest',
      requestData,
      '/api/projectManagement/callBackRequest/callBackClient.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        apiCallToGetPendingRequestList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult.data;
        let totalTestCaseCount = jsonResponse.APIResult?.totaRecords;
        setPendingSortedKey(jsonResponse.APIResult.sorted_key)

        setPendingRequestList(apiResult);
        setPendingRequestFetching(false);
        setTotalRequestCount(totalTestCaseCount);
      } else {
        setPendingRequestList({});
        setPendingRequestFetching(false);
      }
    }
  }


  const validateRequest = () => {
    let validate = true;
    if (moduleId == '') {
      validate = false;
      toast.warning('Please select module');
      setModuleIdWarning('Please select module');
    }
    if (validate) {
      apiCallToRaiseRequest();
    }
  }



  if (!isOpen) return null;

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };
  const statusStyles = {
    Pending: {
      backgroundColor: "#FFF3CD",
      color: "#856404",
    },
    Dialed: {
      backgroundColor: "#D1ECF1",
      color: "#0C5460",
    },
    "But not Received": {
      backgroundColor: "#F8D7DA",
      color: "#721C24",
    },
    "Not Connected": {
      backgroundColor: "#F8D7DA",
      color: "#721C24",
    },
    "Called But Not Received": {
      backgroundColor: "#F8D7DA",
      color: "#721C24",
    },
    Connected: {
      backgroundColor: "#D4EDDA",
      color: "#155724",
    },
  };

  // API CALL METHOD TO PENDING REQUEST LIST
  const apiCallToDeleteRequest = async () => {
    setDeletingRequest(true)
    let requestData = {
      "request_id": deleteRequestId,
      "delete_status": "inactive",
      "deleted_by": config?.faculty_id,
      "iid": config.institute_id
    }

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'pmTool_deleteCallBackRequest',
      requestData,
      '/api/projectManagement/callBackRequest/callBackClient.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        apiCallToDeleteRequest();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        if (jsonResponse.APIResult.status == 'success') {
          toast.success(jsonResponse.APIResult.message)
          apiCallToGetPendingRequestList();
          setDeletingRequest(false)
          setOpenConfirmModal(false);


        } else {
          toast.warning(jsonResponse.APIResult.message)
          setDeletingRequest(false)
          setOpenConfirmModal(false);
        }
      } else {
        setDeletingRequest(false)
        setOpenConfirmModal(false);
      }
    }
  }
  // ARE YOU SURE TO DELETE REQUEST
  const ConfirmDeleteModal = () => {
    if (!openConfirmModal) return null;

    return (
      <>
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              {/* Header */}
              <div className="modal-header" style={{ backgroundColor: '#0465ac', color: '#ffffff' }}>
                <h5 className="modal-title poppins-font">
                  Are You Sure?
                </h5>
                <FontAwesomeIcon
                  icon={["fas", "times"]}
                  onClick={() => setOpenConfirmModal(false)}
                  style={{ cursor: "pointer" }}
                />
              </div>

              {/* Body */}
              <div className="modal-body text-center">
                <p className="poppins-font">
                  Are you sure you want to delete this request?
                </p>
              </div>

              {/* Footer */}
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-secondary"
                  onClick={() => { setOpenConfirmModal(false); setDeleteRequestId('') }}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={confirmDelete}
                >
                  Delete
                </button>
              </div>

            </div>
          </div>
        </div>


      </>
    );
  };

  const confirmDelete = () => {
    apiCallToDeleteRequest(deleteRequestId);
  };

  const handleDeleteRequest = (requestId) => {
    setDeleteRequestId(requestId);
    setOpenConfirmModal(true)

  }

  return ReactDOM.createPortal(
    <div className={isOpen ? "modal fade show" : "modal fade"} id="modalContainer" >
      <div className="modal-dialog RequestPaentDivContainer">
        <div className="modal-content ChildModalDataContainer" >
          <div className="callback-request-header" >
            <p className='poppins-font' style={{ paddingLeft: '10px', fontSize: '18px' }}>Call Back Request</p>
            <FontAwesomeIcon icon={["fas", "times"]} onClick={onClose} fontSize={20} style={{ color: 'linear-gradient(to right, #1FA2FF, #12D8FA, #A6FFCB)' }} />


          </div>

          <div
            className="RequestModalBody"
            style={{ width: '100%', marginBottom: '20px', backgroundColor: '#f9fafb' }}
          >
            <div className='add-request-container'>
              <div className='d-flex flex-column g-2'>
                <select
                  className="form-control requestFilterSelect"
                  value={moduleId}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModuleId(value);

                    if (!value) {
                      setModuleIdWarning("Select Module");
                    } else {
                      setModuleIdWarning("");
                    }
                  }}
                >
                  <option value="">Select Module</option>

                  {/* Loading state */}
                  {moduleListFetching && (
                    <option disabled>Loading modules...</option>
                  )}



                  {/* Data */}
                  {!moduleListFetching &&
                    Object.keys(moduleList).length > 0 && Object.values(moduleList).map((module) => (
                      <option key={module.moduleId} value={module.moduleId}>
                        {module.module_name}
                      </option>
                    ))}
                </select>

                <span className='vm_custom_body3' style={{ color: 'red', fontSize: '12px' }}>{moduleIdWarning}</span>
              </div>

              <button disabled={isRaisingRequest} onClick={validateRequest} className='callback-custom-button executive-assign-btn' sty>
                {isRaisingRequest ? <ButtonLoader /> :
                  <><img src={microPhoneRequest} alt='microPhoneRequest'
                    style={{ marginRight: '6px' }}
                  />
                    <span className='vm_custom_body4'>Raise Request</span></>}

              </button>
            </div>
            <div className='callback-tabs'>
              {
                CALLBACKREQUESTTABS.map((request) => (
                  <p
                    key={request.id}
                    className={`callbackRequestTab ${request.name === activeTab
                      ? "active"
                      : ""
                      }`}
                    onClick={() =>
                      handleTabChange(request.name)
                    }
                  >
                    {request.name}
                  </p>
                ))}
            </div>
            <div className="mb-4 mt-8" style={{ backgroundColor: '#fffffff' }}>
              {activeTab === "Pending Call Request" && (
                pendingRequestFetching ? (
                  <Spinner />
                ) : pendingSortedKey.length > 0 ? (
                  pendingSortedKey.map((key, index) => {
                    let req = pendingRequestList[key];
                    console.log("req", req);

                    return (
                      <div
                        key={req?.request_id}
                        style={{
                          width: "100%",
                          borderBottom: "2px solid #E5E7EB",
                          padding: '16px 16px 20px 0px',
                          background: "#fff",
                          fontFamily: "poppins",
                        }}
                      >
                        {/* HEADER */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: 'column',
                          }}
                        >
                          <span className="text-muted small vm_custom_body3">
                            {"Request ID : "}

                            <span className='poppins vm_custom_body4 bg-light text-dark'  >
                              {req?.request_id}
                            </span>
                          </span>

                          <div className='d-flex justify-content-between'>

                            <span className="fw-bold mb-1 vm_custom_subtitle5">
                              <div className="bg-light text-dark vm_custom_body4">
                                <FontAwesomeIcon
                                  icon={['fas', req?.moduleIcon || 'phone']}
                                  style={{ marginRight: 5 }}
                                />
                                {req?.moduleName}
                              </div>
                              <span className="text-muted small vm_custom_body3">
                                {req?.readableAddedOnDate}
                              </span>
                            </span>
                            {deletingRequest && deleteRequestId === req?.request_id ? <FontAwesomeIcon icon={["fas", "spinner"]} spin style={{ cursor: "pointer", height: '18px', width: '18px' }} /> :
                              <img
                                alt='deleteICon'
                                src={deleteRequestIcon}
                                onClick={() => handleDeleteRequest(req?.request_id)}
                                style={{ cursor: "pointer", height: '18px', width: '18px' }}
                              />}
                          </div>



                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                          className='mb-3'
                        >
                          {/* LEFT SIDE LINE MARKER */}

                          <div className='animationRequest' style={{ marginRight: "15px", width: '100%' }}>

                            <CallQueueIndicator count={req?.previousPendingCount} />
                          </div>
                        </div>

                        {/* FOOTER MESSAGE */}
                        <p className='vm_custom_body5' style={{ color: '#1e1e1e' }}>
                          Our executive will connect with you at the earliest possible time.
                          We truly appreciate your patience and understanding.
                        </p>
                      </div>
                    );
                  })
                ) : (
                  // src/HELPDESK/CommonResources/images/callRequestCenter.gif
                  <div style={{ display: "flex", placeContent: 'center', placeItems: 'center', height: '500px' }}>
                    <img src={callCenterIcon} alt="callRequestCenter" height={'250px'} width={'250px'} />
                  </div>
                ))}


              {activeTab === 'Call History' && (
                historyListFetching ? (
                  <Spinner />
                ) : (
                  sortedKey.length > 0 ? (
                    sortedKey.map((key, index) => {
                      const item = historyList[key];

                      return (
                        <div key={index} className="border-0">
                          <div style={{ borderRadius: '0', borderBottom: '1px solid #E0E6EB', padding: '16px 16px 20px 0px', color: '#f5f5f5' }}>
                            <span className="text-muted small vm_custom_body3">
                              {"Request ID : "}

                              <span className='poppins vm_custom_body4 bg-light text-dark'  >
                                {item?.requestId}
                              </span>
                            </span>
                            {/* Name + Date */}
                            <div className="d-flex justify-content-between align-items-start " style={{ gap: "8px" }}>

                              <div className="d-flex flex-column align-items-start gap-2">
                                <span className="d-flex flex-row  align-items-center" style={{ color: '#000000', gap: "6px" }}>
                                  <span className="vm_custom_subtitle5" style={{ color: '#0465ac' }}>{item?.readableAddedOnDate || "-"}</span>
                                  {item?.callDoneByName && <span className="vm_custom_body3">
                                    {" | "}Call Connected to {item?.callDoneByName || "-"}
                                  </span>}
                                </span>

                                <div className="bg-light text-dark vm_custom_body4">
                                  <FontAwesomeIcon
                                    icon={['fas', item?.moduleIcon || 'phone']}
                                    style={{ marginRight: 5 }}
                                  />
                                  {item?.moduleName}
                                </div>
                              </div>

                              <span
                                className="badge px-3 py-2 fw-bold rounded-pill vm_custom_body4"
                                style={statusStyles[item?.callStatus] || {}}
                              >
                                {item?.callStatus}
                              </span>

                            </div>

                            {/* Remark Box */}
                            {item?.callRemark &&
                              <div className="mt-1 rounded text-break" style={{ color: '#808080' }}>
                                <p className="fw-semibold small mb-1">
                                  <span className="vm_custom_body4">Remark </span>
                                  <span className="vm_custom_body3">
                                    {item?.updatedByName
                                      ? `${item.updatedByName} | ${item.readableUpdatedOnDate}`
                                      : "-"}
                                  </span>
                                </p>

                                <p className="mb-0 vm_custom_body6">
                                  {item?.requestStatus || "-"}
                                </p>
                              </div>
                            }


                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="d-flex flex-column align-items-center py-4">
                      <div style={{ display: "flex", placeContent: 'center', placeItems: 'center', height: '500px' }}>
                        <img src={callCenterIcon} alt="callRequestCenter" height={'250px'} width={'250px'} />
                      </div>
                    </div>
                  )
                )
              )}



            </div>

          </div>

        </div>
      </div>{
        openConfirmModal && <ConfirmDeleteModal />
      }
    </div>,
    document.body
  );
};

export default CallBackRequestModal;
